import { Action } from '../../../../store/state';
import { defaultTaxInfo, taxInfoFields } from '../../Register/data';

export const taxInfoReducer = (
  state: typeof defaultTaxInfo,
  action: Action
): typeof defaultTaxInfo => {
  switch (action.type) {
    case taxInfoFields.IS_VAT_REGISTERED:
      return { ...state, isVATRegistered: action.payload };
    case taxInfoFields.VAT_NUMBER:
      return { ...state, vatNumber: action.payload };
    case taxInfoFields.IS_LLC:
      return { ...state, isLLC: action.payload };
    case taxInfoFields.COMPANY_NAME:
      return { ...state, companyName: action.payload };
    case taxInfoFields.COMPANY_NUMBER:
      return { ...state, companyNumber: action.payload };
    case taxInfoFields.RECEIVE_VAT:
      return { ...state, receiveVAT: action.payload };
    case 'INITIALISE':
      return {
        isVATRegistered: action.payload?.influencer_vat_registered
          ? 'yes'
          : 'no',
        vatNumber: action.payload?.influencer_vat_number ?? '',
        isLLC: action.payload?.influencer_limited_company ? 'yes' : 'no',
        companyName: action.payload?.influencer_company_name ?? '',
        companyNumber: action.payload?.influencer_company_number ?? '',
        receiveVAT: action.payload?.should_include_vat ? 'yes' : 'no',
      };
    case 'CLEAR':
      return defaultTaxInfo;
    default:
      return state;
  }
};
